import { render, staticRenderFns } from "./CTReadingIncorrect.UK.4.vue?vue&type=template&id=f70cd11e&scoped=true"
import script from "./CTReadingIncorrect.UK.4.vue?vue&type=script&lang=js"
export * from "./CTReadingIncorrect.UK.4.vue?vue&type=script&lang=js"
import style0 from "./CTReadingIncorrect.UK.4.vue?vue&type=style&index=0&id=f70cd11e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70cd11e",
  null
  
)

export default component.exports